<template>
  <div class="finance-apply-wrap">
    <el-breadcrumb separator=">" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>融资管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/finance/list' }">融资管理列表</el-breadcrumb-item>
      <el-breadcrumb-item>申请融资</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt">
          可申请融资列表 <span class="apply-tip">温馨提示：支持批量或者单选申请融资</span>
        </span>
      </div>
      <div class="fr">
        <el-button type="primary" id="auto-5" @click="hanldeApply" :disabled="selection.length === 0"
          ><span class="apply-icon"></span>批量申请融资</el-button
        >
      </div>
    </div>
    <div class="table-custom-box" id="auto-0">
      <fe-table
        :tableData="applyData"
        :columns="columns"
        border
        :show-pagination="false"
        @selection-change="selectionChange"
        :max-height="600"
      >
        <template #selection>
          <el-table-column type="selection" width="40"></el-table-column>
        </template>
        <template #invoiceDate="{ scope }">
          <span>{{ scope.row.invoiceDate | stamp2TextDate }}</span>
        </template>
        <template #invoiceAmount="{ scope }">
          <span>{{ scope.row.invoiceAmount | thousands(2) }}</span>
        </template>
      </fe-table>
    </div>

    <el-dialog title="选择融资产品" :visible.sync="dialogVisible" width="720px">
      <div class="apply-list" v-if="productList.length > 0">
        <div
          class="apply-item"
          v-for="(item, idx) in productList"
          :key="idx"
          @click="handleActive(item, idx)"
          :class="{ active: activeIndex == idx }"
        >
          <div class="apply-item-head">
            <span class="apply-item-head_name">{{ item.productName }}</span>
          </div>
          <div class="apply-item-bank">
            <span class="apply-item-bank_tag">资金方</span>
            <span class="apply-item-bank_name">{{ item.fundSideName }}</span>
          </div>
          <div class="apply-item-body">
            <div class="apply-item-body_interest">
              <div class="apply-item-body_name">年利率</div>
              <div class="apply-item-body_val">
                <span class="font-size20">{{ item.annualInterestRate }}</span
                >%
              </div>
            </div>
            <div class="apply-item-body_term">
              <div class="apply-item-body_name">融资期限</div>
              <div class="apply-item-body_val">
                <span class="font-size20">{{ getProductDeadline(item.productDeadlineList) }}</span
                >天
              </div>
            </div>
            <div class="apply-item-body_repayment">
              <div class="apply-item-body_name">还款方式</div>
              <div class="apply-item-body_val repayment">
                <span>{{ item.repaymentTypeDesc }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-data-con">
        <img src="../../assets/img/order/pic120px_qs_zwmx@2x.png" alt="" />
        <div class="no-data-text">暂无产品</div>
      </div>
      <div slot="footer" class="dialog-footer" v-if="productList.length > 0">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="hanldeToApply">申请融资</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import tableMixin from '@/utils/tableMixin';
export default {
  mixins: [tableMixin],
  data() {
    return {
      applyData: [],
      columns: [
        { label: '合同编号', prop: 'contractNumber', 'min-width': 100 },
        { label: '开票日期', prop: 'invoiceDate', 'min-width': 100 },
        { label: '发票号码', prop: 'invoiceNo', 'min-width': 100 },
        { label: '发票类型', prop: 'arInvoiceTypeDesc', 'min-width': 100 },
        { label: '发票金额(元)', prop: 'invoiceAmount', 'min-width': 100 },
        { label: '结算公司', prop: 'settlementCompany', 'min-width': 100 }
      ],
      tableOptions: {},
      axiosConfig: { url: api.queryContractInvoice },
      selection: [],
      productList: [],
      activeIndex: -1,
      activeItem: {},
      dialogVisible: false
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    beforeResolve(result) {
      this.applyData = result || [];
      return true;
    },
    getProductDeadline(arr) {
      return arr.join('天 ');
    },
    selectionChange(selection) {
      this.selection = selection;
    },
    handleActive(item, idx) {
      this.activeIndex = this.activeIndex != idx ? idx : -1;
      this.activeItem = item;
    },
    hanldeApply() {
      // 发票重复检验
      const invoiceNoArr = [];
      const repeatInvoiceNoArr = [];
      this.selection.forEach(el => {
        if (!invoiceNoArr.includes(el.invoiceNo)) {
          invoiceNoArr.push(el.invoiceNo);
        } else {
          repeatInvoiceNoArr.push(el.invoiceNo);
        }
      });
      if (repeatInvoiceNoArr.length) {
        const filterRepeatInvoiceNoArr = [...new Set(repeatInvoiceNoArr)];
        this.$message.error(`发票号码${filterRepeatInvoiceNoArr.join('，')}存在重复，请选择其中一张提交`);
        return;
      }

      // 判断是否有不同的结算公司信用代码
      let result = this.selection.every(item => item.coreCompanyCreditCode === this.selection[0].coreCompanyCreditCode);
      if (!result) {
        this.$message.error('只能选择同一个结算公司');
        return;
      }
      this.activeIndex = -1;
      this.getProductList();
      this.dialogVisible = true;
    },
    async getProductList() {
      let res = await axios.post(api.queryProductList);
      this.productList = res.data || [];
    },
    hanldeToApply() {
      if (this.activeIndex == -1) {
        this.$message.error('请选择产品');
        return;
      }
      this.$router.push({
        name: 'FinanceApplyDetail',
        params: {
          platformProductId: this.activeItem.platformProductId,
          limitNumber: this.activeItem.limitNumber,
          contractNumberList: this.selection
        }
      });
    }
  }
};
</script>
<style lang="postcss" scoped>
.finance-apply-wrap {
  .font-gray {
    color: #aaa;
  }
  .font-f33 {
    color: #333;
  }
  .btn-left-txt {
    position: relative;
    .apply-tip {
      position: relative;
      padding: 5px 10px;
      margin: 0 12px 0 10px;
      background: #fff8f2;
      border-radius: 2px;
      color: #ff6600;
      &:before {
        content: '';
        position: absolute;
        top: 5px;
        left: -16px;
        width: 0;
        height: 0;
        border-width: 8px;
        border-style: solid;
        border-color: transparent #fff8f2 transparent transparent;
      }
      &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        top: 6px;
        left: -16px;
        width: 0;
        height: 0;
        border-width: 9px;
        border-style: solid;
        border-color: transparent transparent #fff transparent;
      }
    }
  }
  .apply-list {
    height: 620px;
    overflow-y: auto;
    .apply-item {
      margin-bottom: 20px;
      cursor: pointer;
      position: relative;
      padding: 20px;
      background: #fff;
      border-radius: 8px;
      border: 1px solid #e9e9e9;
      box-sizing: border-box;
      :before {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        width: 48px;
        height: 48px;
        background: url('../../assets/img/common/ico_special_nor.png') no-repeat;
      }
      &.active {
        :before {
          content: '';
          position: absolute;
          right: 0;
          top: 0;
          width: 48px;
          height: 48px;
          background: url('../../assets/img/common/ico_special_sel.png') no-repeat;
        }
      }
      .apply-item-head {
        .apply-item-head_name {
          margin-right: 8px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
        }
      }
      .apply-item-bank {
        margin-top: 6px;
        .apply-item-bank_tag {
          margin-right: 4px;
          width: 44px;
          height: 20px;
          line-height: 20px;
          background: linear-gradient(293deg, #f7d38f 0%, #ffefc9 100%);
          border-radius: 2px;
          color: #a2643e;
          padding: 0 4px;
        }
        .apply-item-bank_name {
          color: #333;
        }
      }
      .apply-item-body {
        padding: 12px 24px;
        display: flex;
        margin-top: 12px;
        background: #f9fbfe;
        border-radius: 4px;
        .apply-item-body_name {
          color: #aaa;
        }
        .apply-item-body_val {
          color: #333;
        }
        .apply-item-body_interest {
          margin-right: 96px;
        }
        .apply-item-body_term {
          margin-right: 96px;
        }
        .repayment {
          padding: 2px 6px;
          color: #aaa;
          border-radius: 2px;
          border: 1px solid #e9e9e9;
          font-size: 12px;
          color: #333;
        }
      }
    }
  }
  .apply-icon {
    width: 16px;
    height: 16px;
    display: inline-block;
    background: url('../../assets/img/finance/icopx_yd_sqrz.png') no-repeat;
    background-size: 16px 16px;
    vertical-align: text-bottom;
    margin-right: 4px;
  }
  .no-data-con {
    text-align: center;
    img {
      width: 120px;
      height: 120px;
    }
    .no-data-text {
      font-size: 14px;
      font-weight: 400;
      color: #aaaaaa;
      margin-top: 16px;
    }
  }
}
</style>
